module.exports = __webpack_public_path__ + "img/city-street.4fad7adf.png";